import z from "zod";

export const lifeClientOptionsSchema = z.object({
  serverUrl: z.string().prefault("http://localhost:3003"),
  serverToken: z.string().optional(),
});

export type LifeClientOptions = z.output<typeof lifeClientOptionsSchema>;
